import { render } from "./CollectionFilterAccordion.vue?vue&type=template&id=0e76a4e4"
import script from "./CollectionFilterAccordion.vue?vue&type=script&lang=js"
export * from "./CollectionFilterAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__